module.exports = __webpack_public_path__ + "img/LUB00134.ed409570.png";